import React, { memo } from "react";
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";
import infoFilled12 from "@swiggy-private/dls-web-icons/dist/web/generic/infoFilled/12";
import { GenericIconContainer, Subtext } from "./styles";

interface ItemSublabelProps {
    text?: string;
    isItemOutOfStock?: boolean;
}

const ItemSublabel = ({ text, isItemOutOfStock }: ItemSublabelProps) => {
    return (
        <Subtext variant="V2.body3.neutral.regular" color={isItemOutOfStock ? "text_disabled" : "text_Low_Emphasis"}>
            {text}
            <GenericIconContainer>
                <GenericIcon Icon={infoFilled12} fillColor={isItemOutOfStock ? "text_disabled" : "text_Low_Emphasis"} />
            </GenericIconContainer>
        </Subtext>
    );
};

export default memo(ItemSublabel);
